"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.cleanStores = exports.clean = void 0;
const index_js_1 = require("../task/index.js");
exports.clean = Symbol('clean');
let cleanStores = (...stores) => {
    if (process.env.NODE_ENV === 'production') {
        throw new Error('cleanStores() can be used only during development or tests');
    }
    (0, index_js_1.cleanTasks)();
    for (let store of stores) {
        if (store) {
            if (store.mocked)
                delete store.mocked;
            if (store[exports.clean])
                store[exports.clean]();
        }
    }
};
exports.cleanStores = cleanStores;
